module.exports = __webpack_public_path__ + "static/media/safari-desktop-step-1.5661e7e0.png";